export const NEW_ORDERS_TAB = 'new';
export const CONFIRMED_ORDERS_TAB = 'confirmed';
export const PICKUP_SCHEDULED_ORDERS_TAB = 'pickup_scheduled';
export const CANCELLED_ORDERS_TAB = 'cancelled';
export const COMPLETED_ORDERS_TAB = 'completed';
